import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TableColumnWidthInfo } from '@devexpress/dx-react-grid';

import { getBundleGuidFromRowId, isBundleRow } from '../selectors/backlogGrid';
import { bundleDeleted, bundlesLoaded } from './bundlesSlice';

interface BacklogGridState {
  readonly checkedRows: string[];
  readonly expandedRows: string[];
  readonly userColumnWidths: TableColumnWidthInfo[] | null;
}

const initialState: BacklogGridState = {
  checkedRows: [],
  expandedRows: [],
  userColumnWidths: null,
};

const backlogGridSlice = createSlice({
  name: 'backlogGrid',
  initialState,
  reducers: {
    expandRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.expandedRows.includes(rowId)) continue;
        state.expandedRows.push(rowId);
      }
    },
    collapseRows: (state, action: PayloadAction<readonly string[]>) => {
      state.expandedRows = state.expandedRows.filter((expandedRow) => !action.payload.includes(expandedRow));
    },
    checkRows: (state, action: PayloadAction<readonly string[]>) => {
      for (const rowId of action.payload) {
        if (state.checkedRows.includes(rowId)) continue;
        state.checkedRows.push(rowId);
      }
    },
    uncheckRows: (state, action: PayloadAction<readonly string[]>) => {
      state.checkedRows = state.checkedRows.filter((checkedRow) => !action.payload.includes(checkedRow));
    },
    setUserColumnWidths: (state, action: PayloadAction<TableColumnWidthInfo[]>) => {
      state.userColumnWidths = action.payload;
    },
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(bundlesLoaded, (state) => {
      state.checkedRows = [];
    });
    builder.addCase(bundleDeleted, (state, action) => {
      function isDeletedBundleRow(rowId: string) {
        return isBundleRow(rowId) && getBundleGuidFromRowId(rowId) === action.payload.guid;
      }
      state.checkedRows = state.checkedRows.filter((rowId) => !isDeletedBundleRow(rowId));
      state.expandedRows = state.expandedRows.filter((rowId) => !isDeletedBundleRow(rowId));
    });
  },
});

export const { expandRows, collapseRows, checkRows, uncheckRows, setUserColumnWidths } = backlogGridSlice.actions;
export const backlogGrid = backlogGridSlice.reducer;
